/* Wyld Chics — footer (sections/wc-footer.liquid)
   1. Menus are <details>: accordions on phones, always open as columns from 750px.
   2. Join form -> Klaviyo client API (same calls as wc-notify.js): email into the Email List,
      phone into the SMS List, and a number is only sent when the consent box is ticked. */
(function () {
  'use strict';
  var REVISION = '2026-07-15';   // same revision as wc-notify.js; 2024-10-15 rejected the profile's subscriptions field with a 400
  var mq = window.matchMedia('(min-width: 750px)');

  function syncMenus() {
    document.querySelectorAll('[data-wc-footer-menu]').forEach(function (d) {
      if (mq.matches) d.setAttribute('open', '');
      else if (!d.hasAttribute('data-user-opened')) d.removeAttribute('open');
    });
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('[data-wc-footer-menu]') && !mq.matches) {
      if (d.open) d.setAttribute('data-user-opened', ''); else d.removeAttribute('data-user-opened');
    }
  }, true);
  if (mq.addEventListener) mq.addEventListener('change', syncMenus); else mq.addListener(syncMenus);
  syncMenus();

  function e164(raw) {
    var s = (raw || '').replace(/[^\d+]/g, '');
    if (!s) return '';
    if (s[0] === '+') return /^\+\d{8,15}$/.test(s) ? s : null;
    var d = s.replace(/\D/g, '');
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d[0] === '1') return '+' + d;
    return null;
  }
  function post(path, body, key) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION }, body: JSON.stringify(body)
    }).then(function (r) { if (r.status >= 200 && r.status < 300) return r; return r.text().then(function (t) { throw new Error(path + ' ' + r.status + ' ' + t.slice(0, 200)); }); });
  }
  function subscription(list, attrs, source) {
    return { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target && evt.target.closest ? evt.target.closest('[data-wc-join]') : null;
    if (!form) return;
    evt.preventDefault();
    if (form.getAttribute('data-busy')) return;
    var key = form.getAttribute('data-key'), emailList = form.getAttribute('data-email-list'), smsList = form.getAttribute('data-sms-list');
    var emailEl = form.querySelector('[data-wc-join-email]'), phoneEl = form.querySelector('[data-wc-join-phone]'), consentEl = form.querySelector('[data-wc-join-consent]');
    var err = form.querySelector('[data-wc-join-error]'), perr = form.querySelector('[data-wc-join-phone-error]'), done = form.querySelector('[data-wc-join-done]'), btn = form.querySelector('[data-wc-join-submit]');
    var email = emailEl.value.trim(), phone = e164(phoneEl.value), consent = !!(consentEl && consentEl.checked);
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
    err.hidden = true; perr.hidden = true;
    emailEl.setAttribute('aria-invalid', emailOk ? 'false' : 'true');
    phoneEl.setAttribute('aria-invalid', phoneEl.value.trim() && phone === null ? 'true' : 'false');
    if (!emailOk || phone === null || !key || !emailList) { err.hidden = false; return; }
    if (phone && !consent) { phoneEl.setAttribute('aria-invalid', 'true'); perr.hidden = false; return; }

    form.setAttribute('data-busy', '1'); btn.setAttribute('aria-busy', 'true');
    var calls = [post('subscriptions', subscription(emailList, { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }, 'Footer join'), key)];
    if (phone && smsList) calls.push(post('subscriptions', subscription(smsList, { email: email, phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } }, 'Footer join (SMS)'), key));
    Promise.all(calls).then(function () {
      form.classList.add('is-done'); done.hidden = false;
    }).catch(function (e) {
      if (window.console) console.warn('[wc-footer] join failed:', e && e.message);
      err.hidden = false;
    }).then(function () { form.removeAttribute('data-busy'); btn.removeAttribute('aria-busy'); });
  }, true);

  // language switcher in the legal row: the clicked button's locale also goes into the hidden locale_code input
  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest ? evt.target.closest('[data-wc-lang]') : null;
    if (!btn || !btn.form) return;
    var input = btn.form.querySelector('input[type="hidden"][name="locale_code"]');
    if (input) input.value = btn.value;
  });
})();
